import React from "react";
import "./ServicesHero.css";

const ServicesHero = () => {
  return (
    <section className="services-hero">
      <h1 className="seo-hidden">
        Jewellery Website & App Development Services in Ahmedabad
      </h1>
      <h1>Technology Solutions Built for Jewellery Businesses</h1>
      <p>
        At BA Code Solution, we provide custom web and mobile application
        development services designed specifically for the jewellery industry.
        Our solutions help businesses streamline operations, improve customer
        experience, and scale with confidence.
      </p>
    </section>
  );
};

export default ServicesHero;
